<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-input
          placeholder="请输入用户UID"
          clearable
          v-model="tenantUserId"
          size="mini"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-input
          placeholder="请输入邀请人UID"
          clearable
          v-model="inviteBy"
          size="mini"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-select
          v-model="type"
          placeholder="用户范围"
          size="mini"
          class="user-range-select"
        >
          <el-option label="隐藏（仅普通用户）" :value="1" />
          <el-option label="显示（普通+模拟+特殊）" :value="2" />
        </el-select>
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          align="right"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          unlink-panels
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="mini"
          clearable
          :picker-options="pickerOptions"
        >
        </el-date-picker>
        <el-button type="primary" size="mini" @click="handleSearch"
          >搜索</el-button
        >
        <el-button size="mini" @click="handleReset">重置</el-button>
      </div>
      <user-risk-panel-list @refresh="refreshList" />
    </el-card>
  </div>
</template>

<script>
import "./store";
import { mapActions, mapState } from "vuex";
import UserRiskPanelList from "./components/list";

export default {
  name: "UserRiskPanel",
  components: {
    UserRiskPanelList,
  },
  data() {
    const formatDate = (date) => {
      const y = date.getFullYear();
      const m = `${date.getMonth() + 1}`.padStart(2, "0");
      const d = `${date.getDate()}`.padStart(2, "0");
      return `${y}-${m}-${d}`;
    };
    const today = formatDate(new Date());
    return {
      tenantUserId: "",
      inviteBy: "",
      type: 1,
      dateRange: [today, today],
      orderBy: "",
      desc: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("userRiskPanel", ["pagination"]),
  },
  methods: {
    ...mapActions("userRiskPanel", ["list"]),
    formatDate(date) {
      const y = date.getFullYear();
      const m = `${date.getMonth() + 1}`.padStart(2, "0");
      const d = `${date.getDate()}`.padStart(2, "0");
      return `${y}-${m}-${d}`;
    },
    buildQuery(extra = {}) {
      const query = {
        page: this.pagination.page,
        size: this.pagination.size,
        type: this.type,
        ...extra,
      };
      const uid = String(this.tenantUserId || "").trim();
      const invite = String(this.inviteBy || "").trim();
      if (uid) query.tenantUserId = uid;
      if (invite) query.inviteBy = invite;
      if (this.dateRange && this.dateRange.length === 2) {
        query.startTime = this.dateRange[0];
        query.endTime = this.dateRange[1];
      }
      if (this.orderBy) query.orderBy = this.orderBy;
      if (this.desc) query.desc = this.desc;
      return query;
    },
    refreshList(data = {}) {
      if (Object.prototype.hasOwnProperty.call(data, "orderBy")) {
        this.orderBy = data.orderBy;
      }
      if (Object.prototype.hasOwnProperty.call(data, "desc")) {
        this.desc = data.desc;
      }
      this.list(this.buildQuery(data));
    },
    handleSearch() {
      this.refreshList({ page: 1 });
    },
    handleReset() {
      const today = this.formatDate(new Date());
      this.tenantUserId = "";
      this.inviteBy = "";
      this.type = 1;
      this.dateRange = [today, today];
      this.orderBy = "";
      this.desc = "";
      this.list(this.buildQuery({ page: 1, size: this.pagination.size }));
    },
  },
  mounted() {
    this.handleSearch();
  },
};
</script>

<style lang="less" scoped>
.user-range-select {
  width: 180px;
}
</style>
